/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type OrganisationSelector_list$ref: FragmentReference;
declare export opaque type OrganisationSelector_list$fragmentType: OrganisationSelector_list$ref;
export type OrganisationSelector_list = {|
  +organisations: ?$ReadOnlyArray<?{|
    +orgName: ?string,
    +pk: ?number,
    +sites: ?number,
  |}>,
  +$refType: OrganisationSelector_list$ref,
|};
export type OrganisationSelector_list$data = OrganisationSelector_list;
export type OrganisationSelector_list$key = {
  +$data?: OrganisationSelector_list$data,
  +$fragmentRefs: OrganisationSelector_list$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "OrganisationSelector_list",
  "type": "RelayQuery",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "organisations",
      "storageKey": null,
      "args": null,
      "concreteType": "OrganisationDetails",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "orgName",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "pk",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "sites",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '08ebd87104442b2971cf429ef361356e';
module.exports = node;
